import { selectFeatureFlags } from 'core/userContext';
import { GraphQLCampaign } from 'modules/campaigns/lib';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useCampaignAlertsContext } from '../context/CampaignAlertsContext';
import { useCreateAndScheduleCampaignAlertsMutation } from './useCreateAndScheduleCampaignAlertsMutation';
import { useScheduleCampaignAlertsMutation } from './useScheduleCampaignAlertsMutation';

export const useGenerateCampaignAlerts = () => {
  const {
    CampaignPerformanceAlerts: isCampaignPerformanceAlertsEnabled,
    CampaignAlertOverrides: isCampaignAlertOverridesEnabled,
  } = useSelector(selectFeatureFlags);

  const { refetchCampaignAlerts } = useCampaignAlertsContext();

  const { createAndScheduleCampaignAlerts } = useCreateAndScheduleCampaignAlertsMutation();
  const { scheduleCampaignAlertsOnly } = useScheduleCampaignAlertsMutation();

  const generateCampaignAlerts = useCallback(
    ({
      id,
      campaignAlertsEnabled,
    }: {
      campaignAlertsEnabled: GraphQLCampaign['campaignAlertsEnabled'];
      id: GraphQLCampaign['id'];
    }) => {
      if (isCampaignPerformanceAlertsEnabled && campaignAlertsEnabled) {
        if (isCampaignAlertOverridesEnabled) {
          /**
           * Only schedule campaign alerts if alert overrides are enabled
           * as alerts should be created at an earlier point
           */
          scheduleCampaignAlertsOnly({
            variables: { campaignId: id },
            onCompleted: () => {
              refetchCampaignAlerts();
            },
          });
        } else {
          /**
           * Create and then schedule campaign alerts simulataneously
           * if overrides are not enabled
           */
          createAndScheduleCampaignAlerts({
            variables: { campaignId: id },
            onCompleted: () => {
              refetchCampaignAlerts();
            },
          });
        }
      }
    },
    [isCampaignPerformanceAlertsEnabled, isCampaignAlertOverridesEnabled],
  );

  return {
    generateCampaignAlerts,
  };
};
